module.exports = __webpack_public_path__ + "static/media/logo.eb765d71.png";